<template>
<div class="home-container pb-5">
    <section class="d-flex flex-column align-items-center gap-4">
        <div class="d-flex flex-column flex-xxl-row align-items-start gap-2 align-items-xxl-center justify-content-xxl-between gap-xxl-5 w-100">
            <h4 class="extra-large-text light-black-color">აქტივობები</h4>
            <div class="common-secondary-search-container">
                <form class="search-form" @submit.prevent="submitSurveySearchForm()"> 
                    <input name="search-input" v-model="surveyFiltersInfoObj.search" id="search-input" type="text" class="primary-input extra-light-text" placeholder="ძებნა"/>
                    <fieldset class="d-flex w-100 justify-content-end gap-2 align-items-center">
                        <Multiselect v-for="(data, i) of activitiesDateSortMultiselectArray" name="ageRangeID" id="ageRangeID" v-model="surveyFiltersInfoObj.dateSort" :options="data.options" :mode="data.mode"
                            :searchable="true" :loading="false" :close-on-select="true" :object="false" :resolve-on-load="false" :min-chars="1"
                            :hideSelected="true" locale="ge" :canDeselect="false" :canClear="false" :required="false"
                            class="extra-light-text light-blue-color custom-multiselect" autocomplete="off" :placeholder="data.placeholder" :disabled="data.isDisabled" insert/>
                        <button type="submit" class="extra-light-text extra-green-color ms-2" style="font-weight: 600; background-color: transparent;">გაფილტვრა</button>
                    </fieldset>
                </form>
            </div>
            <secondaryButton buttonType="button" class="large-text font-weight-600" buttonWidth="max-content" paddingX="15px" @click="this.$router.push('/newSurvey');">
                <template v-slot:content>
                    <p>ახალი გამოკითხვა</p>
                </template>
            </secondaryButton>
            <!-- <router-link to="/newSurvey" style="width: max-content;">
            </router-link> -->
        </div>
        <div class="common-news-activities-survey-grid-container w-100">
            <shortInfoBlock v-if="false" class="common-box-shadow w-100">
                <template v-slot:mainPart>
                    <div class="d-flex align-items-start gap-3">
                        <h6 class="large-text text-start">Lorem ipsum, dolor sit amet consectetur adipisicing.</h6>
                    </div>
                </template>
                <template v-slot:rightTopPart>
                    <button>
                        <img src="@/assets/images/correctionButton.svg" alt="correction Button">
                    </button>
                    <button>
                        <img src="@/assets/images/tableDeleteButton.svg" alt="delete button">
                    </button>
                </template>
                <template v-slot:rightBottomPart>
                    <primaryButtonComponent buttonType="button" buttonWidth="max-content" paddingX="32px" paddingY="8px">
                        <template v-slot:content>
                            <p class="light-text font-weight-600">ნახვა</p>
                        </template>
                    </primaryButtonComponent>
                </template>
                <template v-slot:subPart>
                    <p class="light-text extra-gray-color text-start">გამოქვეყნებული: Lorem, ipsum dolor.</p>
                </template>
            </shortInfoBlock>
            <template v-else v-for="(num, i) of [1, 2, 3, 4, 5, 6,7,8,9]">
                <shortInfoBlock class="common-box-shadow w-100" :isDisabled="true">
                    <template v-slot:mainPart>
                        <div class="d-flex align-items-start gap-3">
                            <h6 class="large-text font-weight-600 text-start">--------------</h6>
                        </div>
                    </template>
                    <template v-slot:rightTopPart>
                        <button>
                            <img src="@/assets/images/correctionButton.svg" alt="correction Button">
                        </button>
                        <button>
                            <img src="@/assets/images/tableDeleteButton.svg" alt="delete button">
                        </button>
                    </template>
                    <template v-slot:rightBottomPart>
                        <primaryButtonComponent buttonType="button" buttonWidth="max-content" paddingX="32px" paddingY="8px">
                            <template v-slot:content>
                                <p class="light-text font-weight-600">ნახვა</p>
                            </template>
                        </primaryButtonComponent>
                    </template>
                    <template v-slot:subPart>
                        <p class="light-text extra-gray-color text-start">გამოქვეყნებული: Lorem, ipsum dolor.</p>
                    </template>
                </shortInfoBlock>
            </template>
        </div>
        <vue-awesome-paginate
            :total-items="surveyPagingInfo.total"
            :items-per-page="surveyPagingInfo.limit"
            :max-pages-shown="4"
            v-model="surveyPagingInfo.offset"
            :hide-prev-next-when-ends="false"
            @click="surveyPaginationClickHandler"
            class="my-3"
        />
    </section>
</div>
</template>
<script>
import Multiselect from '@vueform/multiselect';
import secondaryButton from '@/components/secondaryButton.vue';
import shortInfoBlock from '@/components/shortInfoBlock.vue';
import primaryButtonComponent from '@/components/primaryButtonComponent.vue';
export default {
    data(){
        return {
            activatedFilterMode: 0,
            filteringPagingInfo: {
                surveysearch: "",
                surveydateSort: null,
                surveyOffset: null,
            },
            surveyFiltersInfoObj: {
                search: "",
                dateSort: null,
            },
            activitiesDateSortMultiselectArray: [
                {
                    placeholder: "სორტირება თარიღით",
                    options: [
                        {
                            value: 1,
                            label: {
                                ge: "თარიღი კლებადობით",
                                en: "date descending",
                            }
                        },
                        {
                            value: 2,
                            label: {
                                ge: "თარიღი ზრდადობით",
                                en: "date ascending",
                            }
                        },
                    ],
                    mode: "single",
                    isDisabled: false,
                },
            ],
            surveyPagingInfo: {
                limit: 9,
                offset: 1,
                total: 90,
            },
        }
    },
    components: {
        Multiselect,
        secondaryButton,
        shortInfoBlock,
        primaryButtonComponent,
    },
    mounted(){
        this.routerMountMovement(this.$route);
    },
    beforeRouteUpdate(to, from, next){
        let isQueriesValid = this.getInfoFromRoute(to);
        
        if(isQueriesValid){
            if(this.activatedFilterMode == 0){
                // this.manageActivitiesFilters();
                // this.manageNewsFilters();
                this.manageSurveyFilters();

            }else if(this.activatedFilterMode == 1){
                this.manageSurveyFilters();
                // this.manageActivitiesFilters();
            }
            next(true);
        }else{
            next(false);
            this.$helper.showSwal("არასწორი მისამართი", "error", "");
        }
        this.activatedFilterMode = 0;
    },
    methods: {
        routerMountMovement(to){
            let isQueriesValid = this.getInfoFromRoute(to);
        
            if(isQueriesValid){
                
                this.manageSurveyFilters();
            }else{
                this.$router.replace(this.$route.path);
                this.$helper.showSwal("არასწორი მისამართი", "error", "");
            }
            this.activatedFilterMode = 0;
        },
        getInfoFromRoute(to){
            Object.keys(this.filteringPagingInfo).forEach((key) => {
                this.filteringPagingInfo[key] = to.query[key]?decodeURIComponent(to.query[key].replace(/%/g, '%25')):null;
            })
            
            let isQueriesValid = Object.keys(this.filteringPagingInfo).every((key) => {
                if(key == "surveysearch"){
                    return this.$helper.checkJustOptionalString(this.filteringPagingInfo[key]??"");
                }else if(this.filteringPagingInfo[key] == null){
                    return true;
                }else{
                    return this.$helper.checkOptionalNumber(this.filteringPagingInfo[key]);
                }
            });
            
            return isQueriesValid;
        },
        submitSurveySearchForm(){
            let tempObj = {};
            if(this.$route.query.surveyOffset){
                tempObj.surveyOffset = 0;
            }
            Object.keys(this.surveyFiltersInfoObj).forEach((key) => {
                if((this.surveyFiltersInfoObj[key] || this.surveyFiltersInfoObj[key] === 0)){
                    tempObj[`survey${key}`] = this.surveyFiltersInfoObj[key];
                }
            })
            this.activatedFilterMode = 1;
            let filteredQueries = {};
            Object.keys(this.$route.query).forEach((queryKey) => {
                if(this.surveyFiltersInfoObj.hasOwnProperty(`${queryKey.slice(4)}`) && queryKey.startsWith("survey")){
                }else{
                    filteredQueries[queryKey] = this.$route.query[queryKey];
                }
            })
            
            this.$router.push({
                path: this.$route.path,
                query: {
                    ...filteredQueries,
                    ...tempObj,
                }
            });
        },
        manageSurveyFilters(){
            Object.keys(this.surveyFiltersInfoObj).forEach((key) => {
                if(key == "search"){
                    this.surveyFiltersInfoObj[key] = this.filteringPagingInfo[`survey${key}`];
                }else if(key == "date"){
                }else if(this.filteringPagingInfo[`survey${key}`] || this.filteringPagingInfo[`survey${key}`] === 0){
                    this.surveyFiltersInfoObj[key] = Number(this.filteringPagingInfo[`survey${key}`]);
                }else{
                    this.surveyFiltersInfoObj[key] = this.filteringPagingInfo[`survey${key}`];
                }
            })
            this.surveyFiltersInfoObj.dateSort = (this.surveyFiltersInfoObj.dateSort == 1 || this.surveyFiltersInfoObj.dateSort == 2)?this.surveyFiltersInfoObj.dateSort:1;
            
            this.surveyPagingInfo.offset = this.filteringPagingInfo.surveyOffset?(Number(this.filteringPagingInfo.surveyOffset) + 1):1;
            // this.getActivities();
        },
        surveyPaginationClickHandler(value){
            this.activatedFilterMode = 1;

            this.$router.push({
                path: this.$route.path,
                query: {
                    ...this.$route.query, 
                    surveyOffset: value - 1,
                }
            });
        },
    }
}
</script>
<style scoped lang="scss">
.home-container{
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(2, min-content);
  row-gap: 2em;
}
/* for common secondary search conatainer >> */
.common-secondary-search-container{
    padding: 1em;
    border-radius: 10px;
    width: 100%;
    background-color: var(--secondary-background-color);
}
.common-secondary-search-container .search-form{
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1em;
}
.common-secondary-search-container .primary-input{
    max-width: 520px;
}


</style>